<template>
     <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/08.gif" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第八次全国代表大会简介</p>
                            <p class="margin1">1956年9月15日至27日在北京举行。到会代表1021人，请假5人。列席代表107人。毛泽东致开幕词，刘少奇作政治报告，邓小平作《关于修改党的章程的报告》，周恩来作《关于发展国民经济第二个五年计划的建议的报告》。大会对社会主义改造基本完成以后国内的主要矛盾作出了科学的判断；确定了政治、经济、文化和外交工作的一系列方针；提出了执政党建设的问题，强调要坚持民主集中制和集体领导制度，反对个人崇拜，发展党内民主，加强党和群众的联系。大会通过的《中国共产党章程》体现了执政党的特点，强调贯彻执行党的民主集中制原则和群众路线，规定全国、省、县级代表大会实行常任制。大会通过了《关于政治报告的决议》和《关于发展国民经济第二个五年计划的建议》。大会选举了由97名委员和73名候补委员组成的中央委员会。随后召开的八届一中全会选举了中央政治局及其常务委员会，选举毛泽东为中央委员会主席，刘少奇、周恩来、朱德、陈云为副主席，邓小平为总书记；选举了由17名委员和4名候补委员组成的中央监察委员会。</p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>